import "./Home.css";
import Banner from "../../Components/Banner/Banner";
import Featured from "../../Components/Featured/Featured";
import MostFavorite from "../../Components/MostFavorite/MostFavorite";
import InstaShop from "../../Components/InstaShop";
import SkinTips from "../../Components/SkinTips";
// import HomeAbout from "../../Components/HomeAbout";
import { Helmet } from "react-helmet-async";
import icon from "../../Images/ogIcon.png";
import HomePersonalCare from "../../Components/HomePersonalCare/HomePersonalCare";
import ShopByConcern from "../ShopByConcern/ShopByConcern";
import ShopByCategory from "../../Components/ShopByCategory";
import HomeAbout from "../../Components/HomeAbout";
import ClarissReviews from "../../Components/ProductReviews";

const Home = () => {
  return (
    <div className="home bg-[#eaeade] overflow-hidden">
      <div>
        <Helmet>
          {/* ✅ Optimized Title with Keywords (50–60 chars) */}
          <title>
            Clariss Bangladesh | Organic Skincare & Natural Beauty Products
          </title>

          {/* ✅ Meta Description (Under 160 chars, keyword-rich) */}
          <meta
            name="description"
            content="Clariss Bangladesh offers organic skincare, natural beauty, and eco-friendly wellness products. Shop sustainable and cruelty-free essentials today."
          />

          {/* ✅ Canonical URL */}
          <link rel="canonical" href="https://clariss.com.bd" />

          {/* ✅ Open Graph Tags for Social Media Sharing */}
          <meta property="og:title" content="Clariss Bangladesh – Natural Beauty & Wellness" />
          <meta
            property="og:description"
            content="Explore organic skincare & eco-friendly wellness with Clariss Bangladesh. Cruelty-free & sustainable beauty products made with nature’s best."
          />
          <meta property="og:image" content={icon} />
          <meta property="og:url" content="https://clariss.com.bd" />
          <meta property="og:type" content="website" />

          {/* ✅ Twitter Card for better social previews */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Clariss Bangladesh | Organic Skincare & Natural Beauty"
          />
          <meta
            name="twitter:description"
            content="Discover Clariss Bangladesh – your go-to for natural, organic, and cruelty-free beauty products. Shop eco-friendly skincare now!"
          />
          <meta name="twitter:image" content={icon} />

          {/* ✅ JSON-LD Structured Data for SEO */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Clariss Bangladesh",
                "url": "https://clariss.com.bd",
                "logo": "https://clariss.com.bd/static/media/Clariss-Logo.63340c74383fffd01b19.webp",
                "description": "Clariss Bangladesh offers natural beauty and organic skincare products crafted for wellness, sustainability, and cruelty-free care.",
                "sameAs": [
                  "https://www.facebook.com/clarissbangladesh",
                  "https://www.instagram.com/clarissbangladesh",
                  "https://www.youtube.com/@clarissbangladesh"
                ],
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "16192 Coastal Highway",
                  "addressLocality": "Lewes",
                  "addressRegion": "Delaware",
                  "postalCode": "19958",
                  "addressCountry": "US",
                  "addressCounty": "Sussex County"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+8801 404 403 965",
                  "contactType": "customer service",
                  "availableLanguage": ["English", "Bengali"]
                }
              }
            `}
          </script>
        </Helmet>

        {/* ✅ Hidden SEO-friendly Main Heading */}
        <h1 className="sr-only">
          Clariss Bangladesh – Organic Skincare, Natural Beauty & Wellness Products
        </h1>

        {/* ✅ Core Sections */}
        <Banner />
        <ShopByCategory />
        <HomePersonalCare />
        <HomeAbout/>
        <ShopByConcern />
        <MostFavorite />
        <Featured />
        <SkinTips />
        <ClarissReviews/>
        <InstaShop />
      </div>
    </div>
  );
};

export default Home;
